'use strict';
module.exports = require('../../es/array/find-last-index');
